export const AUTH_COOKIE_NAME = 'user_token';

export const USER_SUPER_ADMIN_ROLE = { value: 'role_super_admin', label: 'Супер админ', weight: 6 };

export const EXTERNAL_USERS_ROLES = [{ value: 'role_admin_merchant', label: 'Внешний Мерчант Админ', weight: 1 }];

export const USER_ROLES = [
  { value: 'role_operator', label: 'Оператор', weight: 2 },
  { value: 'role_support_view', label: 'Саппорт (Только просмотр)', weight: 1 },
  { value: 'role_support_edit', label: 'Техническая поддержка', weight: 3 },
  { value: 'role_fin_manager', label: 'Финансовый менеджер', weight: 3 },
  { value: 'role_user_check', label: 'Контроль пользователей', weight: 3 },
  { value: 'role_user_view', label: 'Контроль пользователей (Только просмотр)', weight: 3 },
  { value: 'role_manager', label: 'Менеджер', weight: 3 },
  { value: 'role_admin_view', label: 'Админ (Только просмотр)', weight: 4 },
  { value: 'role_admin', label: 'Админ', weight: 5 },
  ...EXTERNAL_USERS_ROLES,
];

export const patternInt = /^\d*$/;

export const patternWithoutWhitespace = /^\S+$/;

export const patternSnakeCase = /^[a-zA-Z0-9]+(?:[_][a-zA-Z0-9]+)*$/;
